export enum ApiVersion {
    V1 = "/v1",
}

export enum RestEndPoint {
    // ═══════════════════════════════════════════════════════════════════════
    // 👤 Me (Current User)
    // ═══════════════════════════════════════════════════════════════════════
    MeBootstrap = "/me/bootstrap",
    MeUserProfile = "/me/userProfile",
    MeExternalUserId = "/me/external-user-id",
    MeContext = "/me/context",
    MeLicenses = "/me/licenses",
    LicensesDetails = "/licenses/details",
    MeBannersMaxAnalysedMails = "/me/banners/max-analysed-mails",
    MeBannersOrganizationHold = "/me/banners/organization-hold",
    MeOrganizationAiModel = "/me/organization/ai-model",

    // ═══════════════════════════════════════════════════════════════════════
    // 📧 Mails
    // ═══════════════════════════════════════════════════════════════════════
    ScoreMail = "/score-mail",
    GetMailIdsSince = "/mails/getMailIdsSince",
    GetMailsFromInternetMessageIds = "/mails/getMailsFromInternetMessageIds",
    GetMailsInAnyFolderFromInternetMessageIds = "/mails/getMailsInAnyFolderFromInternetMessageIds",
    VerifyMailsExistence = "/mails/verifyMailsExistence",
    AnalysisAndSaveMail = "/mails/analysis-save-mail",
    MailSetSmartLabel = "/mails/smart-label",
    MailSetFocus = "/mails/focus",
    MailSetProcessed = "/mails/processed",
    GetLastProcessedMailSentDate = "/mails/getLastProcessedMailSentDate",
    SearchMailsByCategoriesStatus = "/mails/searchMailsByCategoriesAndStatus",
    DeleteAnalyzedMails = "/mails/deleteAnalyzedMails",
    // Contenu agrégé (attachments/links/events) d'un lot de mails — cache SDK par internetMessageId.
    // Sert de source à l'affichage docs/links/events d'une CustomView (indépendant de la pagination front).
    MailContent = "/mails/content",
    MailForward = "/mails/forward",
    // Récupération à la demande des previews de pièces jointes (batch). Les previews (data URL base64)
    // sont trop lourdes pour être servies par défaut → demandées séparément. Cf. getAttachmentsPreviews.
    MailAttachmentsPreviews = "/mails/attachments/previews",

    // ═══════════════════════════════════════════════════════════════════════
    // 🏢 Organizations
    // ═══════════════════════════════════════════════════════════════════════
    Organizations = "/organizations",
    OrganizationById = "/organizations/:id",
    OrganizationLicenses = "/organizations/:id/licenses",
    OrganizationLicenseExpirationDate = "/organizations/:id/licenses/:orgLicenseId/expiration-date",
    OrganizationUsers = "/organizations/:id/users",
    OrganizationAssignB2BUser = "/organizations/:id/assign-licence-to-b2b-user",
    OrganizationUnassignB2BUser = "/organizations/:id/unassign-licence-to-b2b-user",
    OrganizationReassignB2BUser = "/organizations/:id/reassign-licence-to-b2b-user",
    OrganizationSetAdminRole = "/organizations/:id/set-admin-role",

    // ═══════════════════════════════════════════════════════════════════════
    // ✅ Todo Items
    // ═══════════════════════════════════════════════════════════════════════
    MeTodoItem = "/me/todoItem",
    MeAddTodoItemToDashboard = "/me/addTodoItemToDashboard",
    MeSetTodoItemState = "/me/setTodoItemState",
    MeRemoveTodoItemFromDashboard = "/me/removeTodoItemFromDashboard",
    MePurgeTodosOfPermanentlyDeletedMails = "/me/todoItem/purgeTodosOfPermanentlyDeletedMails",

    // ═══════════════════════════════════════════════════════════════════════
    // 🤖 AI Agents
    // ═══════════════════════════════════════════════════════════════════════
    AiWritingAgent = "/ai/writing-agent",
    AiAnalysisAgent = "/ai/analysis-agent",
    AiConversationAgent = "/ai/conversation-agent",
    // Contrat par étapes de l'assistant (docs/contrat-etapes.md de l'Api-Ai), relayé tel quel.
    AiConversationEtapes = "/ai/conversation-etapes",
    // Contrat par étapes : compacter la conversation (bouton « Compacter »), relayé tel quel.
    AiConversationCompacter = "/ai/conversation-compacter",
    // Contrat par étapes : pouce sous une réponse (identifiant du tour et avis seulement).
    AiConversationAvis = "/ai/conversation-avis",
    // Historique des conversations de l'assistant (contrat par étapes) : liste, une conversation, ses tours.
    AiConversations = "/ai/conversations",
    AiConversationById = "/ai/conversations/:id",
    AiConversationTurns = "/ai/conversations/turns",
    // Projets de l'assistant : un espace personnel (consignes, périmètre de mails) où ranger des conversations.
    AiConversationProject = "/ai/conversations/:id/project",
    // Les faits retenus dans une conversation de l'assistant (« clé = valeur »), remplacés en entier.
    AiConversationMemory = "/ai/conversations/:id/memory",
    AiProjects = "/ai/projects",
    AiAssistantUsage = "/ai/assistant-usage",
    AiProjectById = "/ai/projects/:id",
    AiViewFilterAgent = "/ai/view-filter-agent",
    SttCorrect = "/stt/correct",
    SttExtractFromEmail = "/stt/extract-from-email",

    // ═══════════════════════════════════════════════════════════════════════
    // 🏞 CustomViews
    // ═══════════════════════════════════════════════════════════════════════
    CustomViews = "/customViews",
    CustomViewById = "/customViews/:id",
    /** Mise à jour portant la composition datée. La route historique reste servie par l'API
     *  pour les applications mobiles déjà installées. */
    CustomViewV2ById = "/customViews_v2/:id",
    CustomViewTodos = "/customViews/:id/todos",
    CustomViewsCount = "/customViews/count",
    FavoriteCustomViews = "/customViews/favorites",
    CustomViewSetNote = "/customViews/:id/note",

    // ═══════════════════════════════════════════════════════════════════════
    // 🏷 SmartLabels (projection dynamique — pas de persistance DB)
    // ═══════════════════════════════════════════════════════════════════════
    SmartLabels = "/smartLabels",
    SmartLabelByLabel = "/smartLabels/:label",

    // ═══════════════════════════════════════════════════════════════════════
    // ✍️ User Signatures
    // ═══════════════════════════════════════════════════════════════════════
    MeAllSignatures = "/me/signatures",
    MeSignature = "/me/signature",
    MeSignatureById = "/me/signature/:id",

    // ═══════════════════════════════════════════════════════════════════════
    // 👥 Contacts
    // ═══════════════════════════════════════════════════════════════════════
    ContactPhoto = "/contacts/photo",
    ContactSearch = "/contacts/search",
    ContactRagInitialize = "/contacts/rag-initialize",
}

export enum RequestMethod {
    GET = "GET",
    DELETE = "DELETE",
    POST = "POST",
    PUT = "PUT",
    PATCH = "PATCH",
}

export enum TARGET_API_V2 {
    Api_Local = "ApiBackend_Local",
    Api_Dev = "ApiBackend_Dev",
    Api_Recette = "ApiBackend_Recette",
    Api_Prod = "ApiBackend_Prod",
}

export const API_CONFIG_v2: Record<TARGET_API_V2, string> = {
    [TARGET_API_V2.Api_Local]: "http://localhost:7072/api",
    [TARGET_API_V2.Api_Dev]:
        "https://mailvista-api-backend-dev.azurewebsites.net/api",
    [TARGET_API_V2.Api_Recette]:
        "https://mailvista-api-backend-recette.azurewebsites.net/api",
    [TARGET_API_V2.Api_Prod]:
        "https://mailvista-api-backend-prod.azurewebsites.net/api",
};
